module.exports = __webpack_public_path__ + "static/img/loginBack2.3d665c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginBack2.jpg
// module id = z+KM
// module chunks = 3